'use strict'

export let english={
  general: {
    executive: "Executive",
    sro: "SRO",
    projectManager: "PM",
    programmeManager: "PM",
    risks:"Risks",
    issues :"Issues"
  },
  reports: {
    heading: "Generated reports",
    highlightReport: "Latest Highlight Report",
    endProjectReport: "End Project Report",
    brief: "Project Brief",
    pid: "Project Initiation Document"
  },
  link: {
    heading: "Links",
    edit: {
      textPlaceholder: "Display text",
      addressPlaceholder: "Address"
    },
    save: "OK",
    cancel: "Cancel",
    exitEdit: "Exit edit mode",
    add: "Add link",
    goToProduct: "Go to product"
  },
  status: {
    summaryStatus: "Summary Status",
    portfolio: "Portfolio",
    numberOfProjects: "# Activities",
    priority: "Priority",
    name: "Name",
    status: "Status",
    stage: "Part",
    benefits: "Benefits",
    time: "Time",
    cost: "Cost",
    quality: "Quality",
    scope: "Scope",
    risk: "Risk"
  },
  keyInformation: {
    keyInformation: "Key Information",
    identifier: "Identifier",
    projectStage: "Stage"
  },
  themes: {
    background: {
      title: "Background"
    },
    definition: {
      title: "Definition",
    },
    businessCase: {
      title: "Business Case",
    },
    quality: {
      title: "Quality",
    },
    organization: {
      title: "Organization",
    },
    risk: {
      title: "Risk",
    },
    plan: {
      title: "Plans",
    },
    change: {
      title: "Change",
    },
    progress: {
      title: "Progress",
    }
  },
  startupProcess: {
    title: "Recommended activities when starting up a project:",
    help: `Click on an activity below to execute it. Each activity will populate a part of the Project Brief. You do not have to complete all activities to
      move on and have the Project Brief Approved, but you should make sure there is sufficient information to ensure the project is viable and
      worthwhile.`,
    activities: {
      appointExecutiveAndPM: {
        title: "Appoint Executive and PM",
        help: `Select a decision maker, the Executive, with appropriate authority to chair the Project Board, and name the Project Manager for this project. All projects must have an Executive from the very beginning. The Executive is the ultimately responsible for the project.`
      },
      captureLessons: {
        title: "Capture previous lessons",
        help: `Review lessons from previous projects to identify lessons that can be applied to this project. Consult with people with previous experience of similar projects and record relevant lessons identified.`
      },
      appointManagementTeam: {
        title: "Appoint project management team",
        help: `Assign people to each of the roles in the Project Board, assurance roles, support roles and Team Manager roles. The project management team needs to reflect the interests of all parties who will be involved, including business, user and supplier interests. It is vital to have the right people in the appropriate roles and ensure responsibilities are well understood.`
      },
      prepareOutlineBusinessCase: {
        title: "Prepare Outline Business Case",
        help: `Executive should draft the outline business case stating why the project is worth doing. The outline business case is likely to be a high-level view at this time. A more extensive business case must be developed in the initiating a project process.`
      },
      defineProject: {
        title: "Define the project",
        help: `In dialogue with key stakeholders, identify and confirm project objectives, scope, constraints, assumptions, stakeholders and interfaces.`
      },
      describeProjectProduct: {
        title: "Describe Project Product",
        help: `Project Manager should consult with the Senior User, Senior Supplier and Executive to define what the project is to deliver. For each scope statement, what are the deliverables handed over to the line organization when the project is done? Think wide to capture all main deliverables, not deep to capture many requirements. Revise and adjust scope ("Define the project") if necessary to make the structure work.`
      },
      selectApproach: {
        title: "Select Approach",
        help: `Document decisions made regarding how the work of the project is going to be approached. Discuss with Senior Supplier where appropriate resources will come from, if specific working methods or frameworks will apply and if specific technologies will be used.`
      },
      planInitiation: {
        title: "Plan Initiation Stage",
        help: `Create a stage plan for "planning the project". Add a stage representing the work needed to understand and document the project ground rules and the project plan. This is usually the first stage in the project and is covering the Initiating a Project process.`
      },
      assembleBrief: {
        title: "Create a Brief draft for review",
        help: `When sufficient information is gathered to approve the project and to clearly understand the boundaries for the planning of the project, a draft Project Brief should be created and presented to the Project Board for approval. The Initiation Stage Plan should also be presented and approved by the Project Board.`
      }
    },
    nextStep: {
      title: "Approve Project Brief"
    }
  },
  initiationProcess: {
    title: "Recommended activities when initiating a project:",
    help: `Click on an activity below to execute it. Each activity will populate a part of the Project Initiation Document. You do not have to complete
all activities to move on and have the Project Initiation Document approved, but you should make sure there is sufficient information to
ensure a solid foundation for execution of the project.`,
    activities: {
      prepareRiskManagementApproach : {
        title: "Prepare risk management approach",
        help: `The risk management approach describes how risk will be managed and what level of risk is acceptable. What will we do to make sure the level of uncertainty is managed?`
      },
      prepareQualityManagementApproach: {
        title: "Prepare quality management approach",
        help: `The quality management approach describes how to manage quality, including requirement management. What will we do to make sure the projects' products are "fit for purpose"?`
      },
      prepareConfigurationManagementApproach: {
        title: "Prepare change control approach",
        help: `The change control approach describes how changes and issues arising will be managed. What will we do to make sure we have sufficient control of changes?`
      },
      prepareCommunicationManagementApproach: {
        title: "Prepare communication management approach",
        help: `The communication management approach describes how information will be shared in the project team and how the project team will send information to, and receive information from, project stakeholders`
      },
      setupProjectControls: {
        title: "Set up project controls",
        help: `Project Control defines how the Project Board will maintain enough control of the project and how the Project Manager will maintain sufficient control of work managed by the Team Managers.`
      },
      createProjectPlan: {
        title: "Create project plan",
        help: `Build a high level plan broken into management stages. For each stage, define what will be delivered, how much time is needed and what the estimated cost is. Make sure you understand the Project Board's expectation to needed detail level and predictability, and don't waste time going into more details than necessary.`
      },
      refineBusinessCase: {
        title: "Refine business case",
        help: `Executive should provide the business case stating why the project is worth doing`
      },
      defineProject: {
        title: "Revise Project Definition",
        help: `In dialogue with key stakeholders, update and confirm project objectives, scope, constraints, assumptions, stakeholders and interfaces.`
      },
      describeProjectProduct: {
        title: "Revise Project Product Description",
        help: `Project Manager should consult with the Senior User, Senior Supplier and Executive to update what the project is to deliver. For each scope statement, what are the deliverables handed over to the line organization when the project is done? Think wide to capture all main deliverables, not deep to capture many requirements. Revise and adjust scope ("Define the project") if necessary to make the structure work.`
      },
      selectApproach: {
        title: "Revise Project Approach",
        help: `Update decisions made regarding how the work of the project is going to be approached. Discuss with Senior Supplier where appropriate resources will come from, if specific working methods or frameworks will apply and if specific technologies will be used.`
      },
      assemblePID: {
        title: "Create a PID draft for review",
        help: `When sufficient information is gathered and sufficient planning done to start executing the project, a draft Project Initiation Document (PID) should be created and presented to the Project Board for approval. The Stage Plan for the next stage should also be presented and approved by the Project Board.`
      }
    },
    nextStep: {
      title: "Approve Project Initiation Document"
    }
  },
  closeProcess: {
    title: "Recommended activities before closing a project:",
    help: `Before closure of the project can be recommended, the project manager should update the PID and Project Plan, update lessons learned,
close open issues and risks, and prepare an end project report. Make sure to inform all stakeholders.`,
    activities: {
      acceptProducts: {
        title: "Accept products"
      },
      createLessons: {
        title: "Create Lessons",
        help: "Work together with the Project Management Team to identify and document lessons that could be applied to future projects."
      },
      createEndProjectReport: {
        title: "Create End Project Report",
        help: "Assess how successful the project has been and summarize the conclusions in the End Project Report."
      },
      closeRiskRegister: {
        title: "Close Risk Register",
        help: "Close all open risks. Before a risk is closed, evaluate if it should be transferred to a different risk register, for example at a program or a product level"
      },
      closeIssueRegister: {
        title: "Close Issue Register",
        help: "Close all open issues. Before an issue is closed, evaluate if it should be transferred to a different issue register, for example at a program or a product level"
      },
      recommendClosure: {
        title: "Recommend Closure",
        help: "When all closing activities are completed, a closure recommendation should be raised to the board."
      }
    },
    nextStep: {
      title: "Approve Closure"
    },
    cancel: {
      title: "Abort Closure"
    }
  },
  clone: {
    noName: "Clone of"
  }
};



// WEBPACK FOOTER //
// ./views/project/labels/english.js